import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-common_topics-click';

/**
 * Click events on common topics located in the help center retailer/brand home banner.
 */
export function trackHelpCenterCommonTopicsClick(
  retailerToken: string,
  brandToken: string,
  CustomerType: string,
  TopicName2: string,
  TopicUrl3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      retailerToken,
      brandToken,
      CustomerType,
      TopicName2,
      TopicUrl3,
    },
  });
}
